import { fromPairs } from "ramda";

export const convertListToBoolMap = (list = [], value) => fromPairs(list.map((option) => [option, value]))
